import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '@/stores/auth.store';
import { getContext } from './context.api';

/**
 * Contexto de plataforma (modulos activos + nav data-driven) del tenant activo.
 * Reacciona al cambio de tenant via la queryKey.
 */
export function usePlatformContext() {
  const accessToken = useAuthStore((s) => s.accessToken);
  const activeTenantId = useAuthStore((s) => s.activeTenantId);
  return useQuery({
    queryKey: ['context', activeTenantId],
    queryFn: getContext,
    enabled: !!accessToken && !!activeTenantId,
    staleTime: 60_000,
    retry: false,
  });
}
